module.exports = __webpack_public_path__ + "static/media/Full_Vinheta_Sabia.dce2f12a.mp4";